module.exports = __webpack_public_path__ + "img/logo-java.84702086.png";